import React, { useEffect, useState } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { reduxActions, RootState } from '../../../store';
import { store } from '../../..';
import { INavLink, INavLinkGroup, Nav, Shimmer, ShimmerElementsGroup, ShimmerElementType } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';

import { AppAbility } from '../../../shared/CASL/appAbility';
import { Ability, RawRuleOf, subject, Unsubscribe } from "@casl/ability";
import { checkRoles } from '../../../hoc/CheckRoles';
import { RoleContext } from '../../../shared/enums';
import getRawRuleForAdminOrSupervisor from '../../../services/appAbility.service'
import appAbilityService from '../../../services/appAbility.service';
import IndicePAPanel from '../../IndicePA/IndicePAPanel';
import usersService from '../../../services/users.service';
import { IUor } from '../../../shared/interfaces';
const queryString = require('query-string');

export interface SidebarMenuProps {
}
type Props = SidebarMenuProps & RouteComponentProps

const SidebarMenu: React.FunctionComponent<Props> = props => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);
    const selectCurrentUor = (state: RootState) => state.sessionReducer.currentUor;
    const currentUor = useSelector(selectCurrentUor);
    const selectOrganigrammaFlat = (state: RootState) => state.sessionReducer.organigrammaFlat;
    const organigrammaFlat = useSelector(selectOrganigrammaFlat);
    const selectCurrentUser = (state: RootState) => state.sessionReducer.currentUser;
    const currentUser = useSelector(selectCurrentUser);
    const selectAllRoles = (state: RootState) => state.sessionReducer.allRoles;
    const allRoles = useSelector(selectAllRoles);
    const selectFeatures = (state: RootState) => state.sessionReducer.features;
    const features = useSelector(selectFeatures);
    const selectsidebarMenuIsOpen = (state: RootState) => state.sessionReducer.sidebarMenuIsOpen;
    const sidebarMenuIsOpen = useSelector(selectsidebarMenuIsOpen);
    const [sidebarMenuItems, setSidebarMenuItems] = React.useState<INavLink[]>([]);
    const [uorMenuIsExpanded, { setTrue: expandUorMenu, setFalse: collapseUorMenu, toggle: toggleUorMenu }] = useBoolean(false);
    const [adminPanelMenuIsExpanded, { setTrue: expandAdminPanelMenu, setFalse: collapseAdminPanelMenu, toggle: toggleAdminPanelMenu }] = useBoolean(false);
    const [selectedKey, setSelectedKey] = useState<string>();
    const selectIsMobile = (state: RootState) => state.sessionReducer.isMobile;
    const isMobile = useSelector(selectIsMobile);
    const selectIsTablet = (state: RootState) => state.sessionReducer.isTablet;
    const isTablet = useSelector(selectIsTablet);

    const [refresh, setRefresh] = useState<boolean>(false);

    const [indicePAPanelIsOpen, { setTrue: showIndicePAPanel, setFalse: closeIndicePAPanel }] = useBoolean(false);
    const [loadingMenu, { setTrue: showLoadingMenu, setFalse: hideLoadingMenu }] = useBoolean(true);

    let unsubscribeFromAbility: Unsubscribe = () => { };

    let sidebarMenuLinkGroups: INavLinkGroup[] = [{
        links: sidebarMenuItems
    }];

    const onSidebarMenuItemClickHandler = (ev?: React.MouseEvent<HTMLElement>, item?: INavLink) => {
        ev?.stopPropagation();
        ev?.preventDefault();
        if (item && item.url) {
            props.history.push({ pathname: item.url, search: props.location.search });

        }
        if (isMobile === true || isTablet === true) {
            store.dispatch(reduxActions.sessionActions.updateSession({ sidebarMenuIsOpen: false }))
        }
    }

    useEffect(() => {
        setMenu();
    }, []);

    useEffect(() => {
        const { location } = props;
        if (location.pathname.includes('ricerca')) {
            setSelectedKey('ricerca');
        }
        else if (location.pathname.includes('titolario')) {
            setSelectedKey('titolario');
        }

        else if (location.pathname.includes('organigramma')) {
            setSelectedKey('organigramma');
        }
        else if (location.pathname.includes('forwardrules')) {
            setSelectedKey('forwardrules');
        }
        else if (location.pathname.includes('usersaoomanager')) {
            setSelectedKey('usersaoomanager');
        }
        else if (location.pathname.includes('usersmanager')) {
            setSelectedKey('usersmanager');
        }
        else if (location.pathname.includes('featuresmanager')) {
            setSelectedKey('featuresmanager');
        }
        else if (location.pathname.includes('configurationsmanager')) {
            setSelectedKey('configurationsmanager');
        }
        else if (location.pathname.includes('mailboxesmanager')) {
            setSelectedKey('mailboxesmanager');
        }
        else if (location.pathname.includes('protocolregister')) {
            setSelectedKey('protocolregister');
        }
        else if (location.pathname.includes('customcolumnsmanager')) {
            setSelectedKey('customcolumnsmanager');
        }
        else if (location.pathname.includes('aooprotocolviewmanager')) {
            setSelectedKey('aooprotocolviewmanager');
        }
        else {
            const parsedQueryString = queryString.parse(location.search);
            let uorId = parsedQueryString.uorId;
            if (uorId) {
                setSelectedKey(uorId);

            }
        }

    }, [props.location]);

    useEffect(() => {
        setMenu();
    }, [currentAoo, currentUser, refresh, allRoles, features, organigrammaFlat])

    //////////////

    const setMenu = () => {
        const { match, location, history } = props;
        const parsedQueryString = queryString.parse(location.search);

        let newSidebarMenuLinkList: INavLink[] = [];


        //////////// Aggiorno i link delle UOR
        if (currentUser && currentAoo && allRoles && features && organigrammaFlat) {
            /// Attenzione uso abilityBuildForSidebar diverso da abilityBuild usato nel resto dell'app
            /// perch� abilityBuild � condiviso fra tutti i component e viene aggiornato ad ogni routing in base al component da mostrare
            /// quindi pu� avere come context sia AOO che UOR mentre nella sidebar il context � sempre AOO

            // Ottengo le abilit� in base al ruolo dell'utente
            let rulesFromUserRoles: RawRuleOf<AppAbility>[] = appAbilityService.getRawRuleForAdministratorContext(currentUser, allRoles, currentAoo.id);
            // Ottento le abilit� in base alle features attive
            let rulesFromFeatures: RawRuleOf<AppAbility>[] = appAbilityService.getRulesFromFeatures(features);

            let rawRolesForSidebar = rulesFromUserRoles.concat(rulesFromFeatures);
            const abilityBuildForSidebar = new Ability(rawRolesForSidebar);

            const uorsCurrenUserNavLink: INavLink[] = [];
            currentUser.ruoliUorContext.forEach((item) => {
                let uor: IUor | undefined = organigrammaFlat.find(el => el.id! === item.uorId);
                if (item.aooId === currentAoo.id && uor)
                    uorsCurrenUserNavLink.push({
                        name: uor.nome,
                        key: uor.id!.toString(),
                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();

                            parsedQueryString.uorId = item.uorId;
                            const newQueryString = queryString.stringify(parsedQueryString);

                            history.push({ pathname: `/${currentAoo.id}`, search: newQueryString });
                            store.dispatch(reduxActions.sessionActions.updateSession({ currentUor: { ...uor } }))
                        }

                    } as INavLink);
            });


            // Mostro i link sulla Sidebar con push condizionato (sono sempre visibili)
            newSidebarMenuLinkList.push(
                {
                    name: 'UOR',
                    url: '',
                    key: 'uor',
                    links: uorsCurrenUserNavLink,
                    isExpanded: uorMenuIsExpanded,
                    onClick: () => toggleUorMenu
                },
                {
                    name: 'Ricerca',
                    // non uso l'url perch� altrimenti restano i paramtri in queryparams
                    url: '',
                    onClick: (ev) => {
                        ev?.stopPropagation();
                        ev?.preventDefault();
                        history.push({ pathname: `/${currentAoo?.id}/ricerca` });
                    },
                    key: 'ricerca',
                },
                {
                    name: 'Titolario',
                    // non uso l'url perch� altrimenti restano i paramtri in queryparams
                    url: '',
                    onClick: (ev) => {
                        ev?.stopPropagation();
                        ev?.preventDefault();
                        history.push({ pathname: `/${currentAoo?.id}/titolario` });
                    },
                    key: 'titolario',
                },
                {
                    name: 'Organigramma',
                    // non uso l'url perch� altrimenti restano i paramtri in queryparams
                    url: '',
                    onClick: (ev) => {
                        ev?.stopPropagation();
                        ev?.preventDefault();
                        history.push({ pathname: `/${currentAoo?.id}/organigramma` });
                    },
                    key: 'organigramma',
                },
                {
                    name: 'Regole di inoltro',
                    // non uso l'url perch� altrimenti restano i paramtri in queryparams
                    url: '',
                    onClick: (ev) => {
                        ev?.stopPropagation();
                        ev?.preventDefault();
                        history.push({ pathname: `/${currentAoo?.id}/forwardrules` });
                    },
                    key: 'forwardrules',
                }
            );

            // Mostro i link sulla Sidebar con push condizionato in base ai permessi
            // NON ho l'utente associato all'AOO quindi non posso usare la funzione can di CASL
            //if (abilityBuildForSidebar.can('create', 'IUser'))
            if (currentUser.isSuperAdmin || usersService.userDTOIsAdmin(currentUser, currentAoo.id))
                newSidebarMenuLinkList.push(
                    {
                        name: 'Gestione Utenze Aoo',
                        // non uso l'url perch� altrimenti restano i parametri in queryparams
                        url: '',
                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();
                            history.push({ pathname: `/${currentAoo?.id}/usersaoomanager` });
                        },
                        key: 'usersaoomanager',
                    }
                );


            if (abilityBuildForSidebar.can('use', subject('IFeature', { key: 'ProtocolRegister', enabled: true })) && abilityBuildForSidebar.can('read', 'IProtocolRegister'))
                newSidebarMenuLinkList.push(
                    {
                        name: 'Registri di Protocollo',
                        // non uso l'url perch� altrimenti restano i paramtri in queryparams
                        url: '',
                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();
                            history.push({ pathname: `/${currentAoo?.id}/protocolregister` });
                        },
                        key: 'protocolregister',
                    }
                );


            if (abilityBuildForSidebar.can('use', subject('IFeature', { key: 'IndicePA', enabled: true })))
                newSidebarMenuLinkList.push({
                    name: 'Indice PA',
                    // non uso l'url perch� altrimenti restano i paramtri in queryparams
                    url: '',
                    onClick: (ev) => {
                        ev?.stopPropagation();
                        ev?.preventDefault();
                        showIndicePAPanel();
                    },
                    key: 'indicePA',
                });


            let adminPanelNavLinks: INavLink[] = [];
            if (abilityBuildForSidebar.can('read', 'IFeature'))
                adminPanelNavLinks.push(
                    {
                        name: 'Gestione Funzionalit\u00e0',
                        // non uso l'url perch� altrimenti restano i paramtri in queryparams
                        url: '',
                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();
                            history.push({ pathname: `/${currentAoo?.id}/featuresmanager` });
                        },
                        key: 'featuresmanager',
                    }
                );
            if (abilityBuildForSidebar.can('read', 'IArxeiaConfiguration'))
                adminPanelNavLinks.push(
                    {
                        name: 'Gestione Configurazioni',
                        // non uso l'url perch� altrimenti restano i paramtri in queryparams
                        url: '',
                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();
                            history.push({ pathname: `/${currentAoo?.id}/configurationsmanager` });
                        },
                        key: 'configurationsmanager',
                    }
                );
            if (abilityBuildForSidebar.can('use', subject('IFeature', { key: 'PecMail', enabled: true })) && abilityBuildForSidebar.can('create', 'IMailbox'))
                adminPanelNavLinks.push(
                    {
                        name: 'Gestione Posta',
                        // non uso l'url perch� altrimenti restano i paramtri in queryparams
                        url: '',
                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();
                            history.push({ pathname: `/${currentAoo?.id}/mailboxesmanager` });
                        },
                        key: 'mailboxesmanager',
                    }
                );

            if (abilityBuildForSidebar.can('read', 'IColonnaGenerale'))
                adminPanelNavLinks.push(
                    {
                        name: 'Gestione Colonne',
                        // non uso l'url perch� altrimenti restano i paramtri in queryparams
                        url: '',
                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();
                            history.push({ pathname: `/${currentAoo?.id}/customcolumnsmanager` });
                        },
                        key: 'customcolumnsmanager',
                    }
                );


            // Mostro i link sulla Sidebar con push condizionato in base ai permessi
            // NON ho l'utente associato all'AOO quindi non posso usare la funzione can di CASL
            if (currentUser.isSuperAdmin)
                newSidebarMenuLinkList.push(
                    {
                        name: 'Pannello Amministrativo',
                        // non uso l'url perch� altrimenti restano i parametri in queryparams
                        url: '',
                        key: 'adminpanelmenu',

                        links: adminPanelNavLinks,
                        isExpanded: adminPanelMenuIsExpanded,
                        onClick: () => toggleAdminPanelMenu

                    }
                );
            if (currentUser.isSuperAdmin || usersService.userDTOIsAdmin(currentUser, currentAoo.id)) {
                newSidebarMenuLinkList.push(
                    {
                        name: 'Visualizzazioni protocolli',
                        // non uso l'url perch� altrimenti restano i parametri in queryparams
                        url: '',
                        key: 'aooprotocolviewmanager',

                        onClick: (ev) => {
                            ev?.stopPropagation();
                            ev?.preventDefault();
                            history.push({ pathname: `/${currentAoo?.id}/aooprotocolviewmanager` });
                        },

                    }
                );
            }
            setSidebarMenuItems(newSidebarMenuLinkList);
            hideLoadingMenu();
        }
    }
    const dismissIncicePALateralPanel = () => {
        closeIndicePAPanel();
    }


    const getShimmerElements = (): JSX.Element => {
        let lineHeight = 13;
        let gapHeight = 23;
        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>

                <ShimmerElementsGroup
                    flexWrap
                    width={'100%'}
                    shimmerElements={[

                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '35%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '55%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '55%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '80%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '55%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '80%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '35%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '55%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '55%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '80%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '55%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '80%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '55%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '80%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '35%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '55%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '55%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '80%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },


                        { type: ShimmerElementType.gap, width: '100%', height: 0.5 },


                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '55%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '35%', height: gapHeight },

                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },
                        { type: ShimmerElementType.line, width: '80%', height: lineHeight, verticalAlign: 'bottom' },
                        { type: ShimmerElementType.gap, width: '10%', height: gapHeight },

                    ]}
                />

            </div>


        );
    };


    let attachedClasses = sidebarMenuIsOpen ? "layout-menu-wrapper layout-menu-wrapper-active" : "layout-menu-wrapper";

    return (
        <React.Fragment>
            <div className={attachedClasses} >
                <div className={`position-relative my-scroll-div`}>

                    <Shimmer customElementsGroup={getShimmerElements()} isDataLoaded={!loadingMenu}>
                        <Nav
                            ariaLabel="Menu laterale"
                            groups={sidebarMenuLinkGroups}
                            onLinkClick={onSidebarMenuItemClickHandler}
                            selectedKey={selectedKey}

                        />
                    </Shimmer>

                </div>
            </div >
            {indicePAPanelIsOpen &&
                <IndicePAPanel
                    indicePAPanelIsOpen={indicePAPanelIsOpen}
                    onIndicePADismiss={dismissIncicePALateralPanel}
                    {...props}
                />
            }

        </React.Fragment>

    );
};




export default withRouter(SidebarMenu);


